export default __webpack_public_path__ + "static/media/heroBg.b6e61edc.jpg";